// used in ajax injected content to rebind js components
// example of use refreshAttribute('js-slider')(node)
export default (attributeName) => (nodeEl) => {
  const value = nodeEl.getAttribute(attributeName)
  nodeEl.removeAttribute(attributeName)
  nodeEl.setAttribute(attributeName, value)
}
